import React, { useState } from "react";
import { IconButton, InputAdornment } from "@material-ui/core";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@material-ui/icons";
import { FruProControllerTextField } from "components";

export default function ControllerPasswordField(props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FruProControllerTextField
   
      {...props}
      type={showPassword ? "text" : "password"}
      InputProps={{
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword((prev) => !prev)}
              style={{ padding: 0 }}
            >
              {showPassword ? (
                <VisibilityOffIcon
                  fontSize="small"
                  style={{ color: "#BEBEBE" }}
                />
              ) : (
                <VisibilityIcon fontSize="small" style={{ color: "#BEBEBE" }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
